import {
  CATEGORIA_LABEL,
  ROTULO_CAMPO,
  tagConflitos,
  TEXTO_JA_JUSTIFICADO,
} from "@/modules/recursos/simulacao";
import type {
  CampoCartaoLinha,
  CartaoAlteracaoProps,
  CartaoAlteracaoViewModel,
} from "./types-cartao-alteracao";

export function useCartaoAlteracao({
  cartao,
  aviso,
  falha = false,
  mensagem = null,
  children,
}: CartaoAlteracaoProps): CartaoAlteracaoViewModel {
  const campos = cartao.campos.map<CampoCartaoLinha>((campo) => {
    // No cartão Removido a alocação mostra o que ela liberou, com o valor de antes riscado.
    if (cartao.removido && campo.rotulo === ROTULO_CAMPO.alocacao) {
      return { rotulo: campo.rotulo, valor: cartao.removido.liberado, anterior: campo.valor };
    }
    return { rotulo: campo.rotulo, valor: campo.valor, anterior: campo.anterior ?? null };
  });

  return {
    recurso: cartao.recurso,
    removido: cartao.removido,
    titulo: cartao.titulo,
    categoria: CATEGORIA_LABEL[cartao.categoria],
    tagConflito: cartao.conflitos > 0 ? tagConflitos(cartao.conflitos) : null,
    campos,
    aviso,
    falha,
    mensagem,
    ajustePendente: cartao.removido ? null : cartao.ajustePendente,
    jaJustificado: cartao.jaJustificado && !cartao.removido ? TEXTO_JA_JUSTIFICADO : null,
    children,
  };
}
